import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  IconButton,
  Card,
  CardMedia,
  CardContent,
  Avatar,
  Stack,
} from "@mui/material";
import {
  ArrowBackIos,
  ArrowForwardIos,
  ThumbUpAltOutlined,
  ChatBubbleOutline,
} from "@mui/icons-material";

const events = [
  {
    id: 1,
    title: "Wedding Reception: Romeo and Juliet",
    imageUrl: "https://static.wikia.nocookie.net/shrek/images/8/8b/Shrek_fiona_carriage.jpg",
    source: "The Body Optimist",
    likes: 7,
  },
  {
    id: 2,
    title: "Festival of Love in Maputo",
    imageUrl: "https://images.unsplash.com/photo-1521305916504-4a1121188589",
    source: "Event Guide",
    likes: 12,
  },
  {
    id: 3,
    title: "Tech Gala Night",
    imageUrl: "https://images.unsplash.com/photo-1503428593586-e225b39bddfe",
    source: "Future Today",
    likes: 9,
  },
];

const EventSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const next = () => setCurrentIndex((prev) => (prev + 1) % events.length);
  const prev = () => setCurrentIndex((prev) => (prev - 1 + events.length) % events.length);

  useEffect(() => {
    const interval = setInterval(() => {
      next();
    }, 5000); // 5 seconds

    return () => clearInterval(interval); // Cleanup
  }, []);

  return (
    <Card sx={{ position: "relative", overflow: "hidden", borderRadius: 2, width: "100%" , height:"60vh", p:"0"}}>
      <CardMedia
        component="img"
        height="100%"
        image={events[currentIndex].imageUrl}
        alt={events[currentIndex].title}
        sx={{ filter: "brightness(0.6)", objectFit: "cover" }}
      />

      <CardContent
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          color: "#fff",
          width: "100%",
          p: 3,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1}>
          <Avatar sx={{ width: 24, height: 24 }} />
          <Typography variant="subtitle2">{events[currentIndex].source}</Typography>
        </Stack>

        <Typography variant="h6" sx={{ mt: 1 }}>
          {events[currentIndex].title}
        </Typography>

        <Stack direction="row" spacing={2} sx={{ mt: 2 }}>
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <ThumbUpAltOutlined fontSize="small" />
            <Typography variant="body2">{events[currentIndex].likes}</Typography>
          </Stack>
          <ChatBubbleOutline fontSize="small" />
        </Stack>
      </CardContent>

      <IconButton
        onClick={prev}
        sx={{ position: "absolute", left: 10, top: "50%", color: "#fff", zIndex: 1 }}
      >
        <ArrowBackIos />
      </IconButton>

      <IconButton
        onClick={next}
        sx={{ position: "absolute", right: 10, top: "50%", color: "#fff", zIndex: 1 }}
      >
        <ArrowForwardIos />
      </IconButton>

      <Box
        
        sx={{
          position: "absolute",
          bottom: 10,
          width: "100%",
          height: '50vh',
          maxHeight: '50vh',
          display: "flex",
          justifyContent: "center",
          gap: 1,
        }}
      >
        {events.map((_, i) => (
          <Box
            key={i}
            sx={{
              width: 10,
              height: 10,
              borderRadius: "50%",
              backgroundColor: i === currentIndex ? "#fff" : "rgba(255,255,255,0.5)",
            }}
          />
        ))}
      </Box>
    </Card>
  );
};

export default EventSlider;
